<template>
  <section>
    <div class="body-container">
      <h2><span>配信停止の確認</span></h2>
      <div class="edit-box">
        <div class="edit-column">
          <p class="text-lg mb-4">今後のメール配信を停止しますか？</p>
          <div class="flex justify-center gap-4 mt-6">
            <button 
              @click="unsubscribeAction" 
              class="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded"
              :disabled="isLoading"
            >
              配信を停止する
            </button>
            <button 
              @click="closePage" 
              class="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded"
              :disabled="isLoading"
            >
              キャンセル
            </button>
          </div>
        </div>
        <Loading v-if="isLoading" />
      </div>
    </div>
  </section>
</template>

<script>
import Loading from '@/components/animations/Loading'
import directtalk from '@/api/directtalk'

export default {
  name: 'UnsubscribeAction',
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    async unsubscribeAction () {
      this.isLoading = true
      try {
        const seeker_id = this.$route.params.seeker_id
        const response = await directtalk.unsubscribeAction(seeker_id)
        if (response.data.status === 'ok') {
          alert('配信を停止しました')
          this.closePage()
        } else {
            throw new Error('not status ok.')
        }

      } catch (error) {
        console.error('Error unsubscribing:', error)
        alert('処理に失敗しました。時間をおいて再度お試しください。')
      } finally {
        this.isLoading = false
      }
    },
    closePage () {
      window.close()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/UnsubscribeAction.vue